import api from './api';

// Talks to /api/bom/* — the budgeted Bill of Materials for the active version.
export const bomService = {
  // Whole BOM for the active version: { items, lines, settings, warehouses }.
  // Version comes from the x-budget-version-id header (set by the api interceptor).
  getBom: async () => {
    const res = await api.get('/bom');
    return res.data;
  },

  // Every active stock item, for the "add component" picker.
  getStockCodes: async () => {
    const res = await api.get('/bom/stock-codes');
    return res.data;
  },

  // payload: { lines: [ ...changed lines... ], settings: [ ...changed settings... ] }
  saveBom: async (payload) => {
    const res = await api.put('/bom', payload);
    return res.data;
  },
};

export default bomService;
